import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { HERO_IMG } from "@/data/menu";

const LINES = ["Поводът е ваш.", "Преживяването", "създаваме заедно."];
const EASE = [0.22, 1, 0.36, 1];

export const Hero = () => {
  const reduce = useReducedMotion();
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 900], [0, 220]);
  const scale = useTransform(scrollY, [0, 900], [1, 1.12]);

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative flex min-h-[100svh] items-end overflow-hidden md:items-center"
    >
      <motion.div
        className="absolute inset-0 overflow-hidden"
        initial={reduce ? false : { scale: 1.12, opacity: 0.5 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.8, ease: EASE }}
      >
        <motion.img
          src={HERO_IMG}
          alt="Елегантно подредени премиум кетъринг хапки върху плато"
          fetchpriority="high"
          style={reduce ? undefined : { y, scale }}
          className="h-full w-full object-cover will-change-transform"
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/45 to-black/25" aria-hidden="true" />

      <div className="relative mx-auto w-full max-w-7xl px-6 pb-24 pt-40 md:py-52 lg:px-8">
        <motion.p
          initial={reduce ? false : { opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.15 }}
          className="text-xs font-semibold uppercase tracking-[0.3em] text-white/80 md:text-sm"
        >
          B1 &amp; B2 CATERING
        </motion.p>
        <h1 className="mt-6 max-w-3xl font-serif text-4xl font-light leading-[1.12] tracking-tight text-white sm:text-5xl lg:text-6xl">
          {LINES.map((line, i) => (
            <span key={line} className="block overflow-hidden pb-2">
              <motion.span
                className="block will-change-transform"
                initial={reduce ? false : { y: "112%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1.1, ease: EASE, delay: 0.3 + i * 0.14 }}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </h1>
        <motion.p
          initial={reduce ? false : { opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.95 }}
          className="mt-8 max-w-xl text-sm font-light leading-relaxed text-white/85 md:text-lg"
        >
          Специално подбрани кетъринг предложения за гостите на Детски парти клуб
          „Българче“.
        </motion.p>
        <motion.p
          initial={reduce ? false : { opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE, delay: 1.05 }}
          className="mt-4 max-w-xl text-sm font-light leading-relaxed text-white/85 md:text-lg"
        >
          Изберете готова PARTY комбинация и я допълнете с още от любимите си
          предложения според вашето парти.
        </motion.p>
        <motion.div
          initial={reduce ? false : { opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE, delay: 1.15 }}
          className="mt-10 flex flex-col gap-4 sm:flex-row"
        >
          <a
            href="#party"
            data-testid="hero-cta-party"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-accent px-8 py-4 text-sm font-semibold uppercase tracking-wide text-white transition hover:bg-brand-accentHover active:scale-[0.98]"
          >
            Разгледайте готовите комбинации
            <ArrowDown className="h-4 w-4" aria-hidden="true" />
          </a>
          <a
            href="#extras"
            data-testid="hero-cta-extras"
            className="inline-flex items-center justify-center rounded-full border border-white/60 px-8 py-4 text-sm font-semibold uppercase tracking-wide text-white transition hover:border-white hover:bg-white/10 active:scale-[0.98]"
          >
            Разгледайте допълнителните предложения
          </a>
          <a
            href="#sweet"
            data-testid="hero-cta-sweet"
            className="inline-flex items-center justify-center rounded-full border border-white/60 px-8 py-4 text-sm font-semibold uppercase tracking-wide text-white transition hover:border-white hover:bg-white/10 active:scale-[0.98]"
          >
            Разгледайте сладките предложения
          </a>
        </motion.div>
      </div>
    </section>
  );
};
